// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TeacherAuth_wrapper__eTMwZ"};